export default __webpack_public_path__ + "static/media/1318.486961e7.png";